import React, { MutableRefObject } from 'react';
import { useAppSelector } from 'hooks/useAppSelector';
import { HelpContainer } from '../HelpContainer';
import { HelpOptions } from 'store/slices/help';
import { getHelpMessageCss } from 'utils/getHelpMessageCss';
import { ExploreTutorial } from './ExploreTutorial';
import { SaveSpotsTutorial } from './SaveSpotsTutorial';
import { GrowNetworkTutorial } from './GrowNetworkTutorial';

export const InstructionsMessage: React.FC<{
    onShapeChange: (shape: 'circle' | 'square') => void;
    onClickHoleRef: MutableRefObject<() => void>;
}> = ({ onShapeChange, onClickHoleRef }) => {
    const { helpOption, currentMessageIndex, showHelp } = useAppSelector((state) => state.help);

    if (!showHelp || !helpOption) return null;

    const getTutorial = () => {
        switch (helpOption) {
        case HelpOptions.EXPLORE:
            return <ExploreTutorial onShapeChange={onShapeChange} onClickHoleRef={onClickHoleRef}/>;
        case HelpOptions.SAVE_SPOTS:
            return <SaveSpotsTutorial onShapeChange={onShapeChange} onClickHoleRef={onClickHoleRef}/>;
        case HelpOptions.GROW_NETWORK:
            return <GrowNetworkTutorial onShapeChange={onShapeChange} onClickHoleRef={onClickHoleRef}/>;
        default:
            return null;
        }
    };

    return (
        <HelpContainer sx={getHelpMessageCss(helpOption, currentMessageIndex)}>
            {getTutorial()}
        </HelpContainer>
    );
};
